import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";
import { createPandLDashboardData } from "../../graphql/mutations";

export const profitNLossApi = createApi({
  reducerPath: "profitNLoss",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    fetchProfitNLossData: builder.query({
      query: ({ StartDate, EndDate, OpeningBalance }) => ({
        body: createPandLDashboardData,
        variables: {
          StartDate,
          EndDate,
          OpeningBalance,
        },
      }),
      keepUnusedDataFor: Infinity,
      refetchOnMountOrArgChange: true,
      providesTags: ["ProfitNLossData"],
    }),
  }),
});

export const {
  useFetchProfitNLossDataQuery,
  util: { invalidateTags },
} = profitNLossApi;
